<template>
    <span class="flex col-span-4 mt-2 sm:mt-auto sm:justify-end">
        <nav aria-label="Table navigation">
            <ul class="inline-flex items-center">
                <li v-for="(link, key) in links">
                    <button v-if="link.url === null" :key="key" class="px-3 py-1 focus:outline-none focus:shadow-outline-purple">
                        {{ $t(link.label) }}
                    </button>
                    <inertia-link v-else :key="key" :href="link.url" class="px-3 py-1 rounded focus:outline-none focus:shadow-outline-purple" :class="{'bg-purple-600': link.active, 'text-white': link.active}" preserve-scroll>
                        {{ typeof link.label === 'string' ? $t(link.label) : link.label }}
                    </inertia-link>
                </li>
            </ul>
        </nav>
    </span>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        links: Array,
    }
}
</script>
